<template>
   <div>  
        <Header 
            :viewDeals="viewDeals" 
        />
        
        <ModuleMenu 
            :moduleKey="$route.params.mid"
            :projectId="$route.params.pid"
            @quickViewDeals="viewDeals = !viewDeals" />
        
        <div class="container_width">
            <v-dialog
                v-model="dialog"
                max-width="500px"
            >
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ editedItem.label }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="6"
                                >
                                    <v-select
                                        v-model="editedItem.status"
                                        :disabled="editedItem.responsible_party == 'srg' || editedItem.responsible_party == 'not_applicable'"
                                        :items="Object.keys(statusItems).map(key => ({ value: key, text: statusItems[key]}))"
                                        label="Status"
                                    />
                                </v-col>
                                <v-col
                                    cols="6"
                                >
                                    <v-select
                                        v-model="editedItem.responsible_party"
                                        disabled
                                        :items="Object.keys(responsiblePartyItems).map(key => ({ value: key, text: responsiblePartyItems[key]}))"
                                        label="Responsible Party"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                >
                                    <v-menu
                                        ref="menu1"
                                        v-model="dateMenu"
                                        :close-on-content-click="false"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                id="psr_date_picker"
                                                label="Due Date"
                                                :value="editedItem.date ? formatDate(editedItem.date) : ''"
                                                hint="Click the month to quickly change years"
                                                outlined
                                                persistent-hint
                                                prepend-icon="mdi-calendar"
                                                ref="input"
                                                v-on="on"
                                                disabled
                                            />
                                        </template>
                                        <v-date-picker
                                            :min="getMinimumDate()"
                                            no-title
                                            v-model="editedItem.date"
                                            v-on:input="dateMenu = false"
                                        />
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary darken-1"
                        text
                        @click="close"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary darken-1"
                        text
                        @click="save"
                    >
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-tabs
                v-model="tab"
                align-with-title
                background-color="#EFEFEF"
                class="mt-8 sansation"
                hide-slider
                style="border-bottom: 1px solid #5f6062"
                >
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-for="item in items"
                    :key="item"
                >
                    {{ labels[item] }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" style="background-color: #EFEFEF">
                <v-tab-item
                    key="steps"
                >
                    <div class="section-wrapper" v-for="(project_step, index) in projectStepData" :key="index">
                        <h2 class="sansation_subtitle">{{ project_step.label }}</h2>
                        <v-data-table
                            :headers="headers"
                            :items="project_step.tasks.filter( task => task.internal === false)"
                            class="elevation-1"
                            hide-default-footer
                        >

                            <template v-slot:body="{ items }">
                                <tbody>
                                <tr v-for="(item) in items" :key="item.name">
                                    <td class="psr_avenir_book">{{ item.label }}</td>
                                    <td class="psr_avenir_book">{{ labels[`step_status_${item.status}`] }}</td>
                                    <td class="psr_avenir_book">{{ labels[`step_party_${item.responsible_party}`] }}</td>
                                    <td class="psr_avenir_book">{{ item.date ? formatDate(item.date) : '' }}</td>
                                    <td>
                                        <v-icon
                                            class="mr-2"
                                            @click="editItem(item)"
                                        >
                                            mdi-dots-vertical
                                        </v-icon>
                                    </td>
                                </tr>
                                </tbody>
                            </template>                        
                        </v-data-table>
                    </div>
                </v-tab-item>
                <v-tab-item
                    key="meetings"
                >
                    <div class="section-wrapper">
                        <v-data-table
                            :headers="meeting_headers"
                            :items="meetingData"
                            class="elevation-1"
                            hide-default-footer
                        >

                            <template v-slot:body="{ items }">
                                <tbody>
                                    <tr v-for="(item) in items" :key="item.meeting_id">
                                        <td class="psr_avenir_book">{{ item.label }}</td>
                                        <td class="psr_avenir_book">{{ item.start_time ? formatDateTime(item.start_time) : '' }}</td>
                                        <td class="psr_avenir_book">{{ labels[`meeting_status_${item.status}`] }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>
   </div>
</template>

<script>
    import axios from 'axios'
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import { dynamicTitle } from './utilities';

    import Header from './Header'
    import ModuleMenu from './ModuleMenu'

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC'
    });

    const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'short',
        timeStyle: 'short'
    });

    export default {
        name: 'ModuleReport',
        components: {
            Header,
            ModuleMenu,
        },
        data () {
            return {
                module_id: String,
                projectStepData: [],
                meetingData: [],
                tab: 'steps',
                labels: {
                    tab_steps: 'Project Steps',
                    tab_meetings: 'Meetings',
                    meeting_status_scheduled: 'Scheduled',
                    meeting_status_completed: 'Completed',
                    meeting_status_cancelled: 'Canceled',
                    step_party_srg: 'SRG',
                    step_party_client: 'Client',
                    step_party_both: 'Both',
                    step_party_broker_dealer: 'Broker Dealer',
                    step_party_custodian: 'Custodian',
                    step_party_accountant: 'Accountant',
                    step_party_attorney: 'Attorney',
                    step_party_other: 'Other',
                    step_party_not_applicable: 'Not Applicable',
                    step_status_not_started: 'Not Started',
                    step_status_scheduled: 'Scheduled',
                    step_status_in_progress: 'In Progress',
                    step_status_completed: 'Completed',
                    step_status_not_applicable: 'Not Applicable'
                },
                items: ['tab_steps', 'tab_meetings'],
                viewDeals: false,
                dateMenu: false,
                dialog: false,
                editedItem: {},
                meeting_headers: [
                    {
                        text: 'Label',
                        align: 'left',
                        sortable: false,
                        value: 'label'
                    },
                    { 
                        text: 'Time', 
                        value: 'start_time',
                        sortable: false,
                        width: '250px'
                    },
                    { 
                        text: 'Status', 
                        value: 'status',
                        sortable: false,
                        width: '150px'
                    }
                ],
                headers: [
                    {
                        text: 'Task',
                        align: 'left',
                        sortable: false,
                        value: 'label'
                    },
                    { 
                        text: 'Status', 
                        value: 'status_label',
                        sortable: false,
                        width: '150px'
                    },
                    { 
                        text: 'Responsible Party', 
                        value: 'responsible_party_label',
                        sortable: false,
                        width: '150px'
                    },
                    {
                        text: 'Due Date', 
                        value: 'date_label',
                        sortable: false,
                        width: '150px'
                    },
                    {
                        value: 'actions',
                        width: '50px'
                    }
                ],
                responsiblePartyItems: {
                    'srg': 'SRG',
                    'client': 'Client',
                    'both': 'Both',
                    'broker_dealer': 'Broker Dealer',
                    'custodian': 'Custodian',
                    'accountant': 'Accountant',
                    'attorney': 'Attorney',
                    'other': 'Other',
                    'not_applicable': 'Not Applicable'
                },
                statusItems: {
                    'not_started': 'Not Started',
                    'scheduled': 'Scheduled',
                    'in_progress': 'In Progress',
                    'completed': 'Completed',
                    'not_applicable': 'Not Applicable'
                }
            }
        },

        created () {
            document.title = dynamicTitle( 'Project Status Report: ', this.$route.params )
        },

        mounted() {
            this.getStatusReport();
        },
        methods: {
            checkUser: async function () {
                try {
                    const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    if(user_check.data.outcome) {                        
                        return true
                    } else {
                        console.log(user_check.data.message)
                        return false
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            formatDate (date) {
                const formatted =  dateFormatter.format(new Date(date));

                return formatted;
            },

            formatDateTime (date) {
                const formatted =  dateTimeFormatter.format(new Date(date));

                return formatted;
            },

            getMinimumDate () {
                // "today" - nothing from today backwards
                const now = new Date();
                const year = String(now.getFullYear()).padStart(4, '0');
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const date = String(now.getDate()).padStart(2, '0');

                return `${year}-${month}-${date}`;
            },

            getStatusReport: async function () {
                try {
                    const user_check = await this.checkUser()
                
                    if ( user_check ) {
                        const status_report = await axios.get(
                            `${appUrls.api}/api/project/${this.$route.params.pid}/project_status_report`, 
                            {
                                headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                            }
                        );

                        const { data } = status_report;
                        const { projectSteps, meetings } = data;

                        this.meetingData = meetings;
                        this.projectStepData = projectSteps

                        this.projectStepData = this.projectStepData.filter((projectStep) => {
                            const tasks = projectStep.tasks.filter((task) => task.internal === false);

                            return tasks.length > 0;
                        });

                    } else {
                        throw error
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            editItem (item) {
                const { task_id } = item;
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            close () {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = {};
                }, 300)
            },

            async save () {
                const { task_id, label, projectstep_id, status, date, responsible_party } = this.editedItem;

                const taskSave = await axios.put(
                    `${appUrls.api}/api/project_step/${projectstep_id}/task/${task_id}`,
                    {
                        status,
                        date,
                        responsible_party,
                        label
                    },
                    {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    }
                );
                const taskData = taskSave.data[0];

                this.projectStepData = this.projectStepData.map((thisProjectStep) => {
                    if (thisProjectStep.projectstep_id === projectstep_id) {
                        const tasks = thisProjectStep.tasks.map((thisTask) => {
                            if (thisTask.task_id === task_id) {
                                return taskData;
                            }

                            return thisTask;
                        });

                        return {
                            ...thisProjectStep,
                            tasks
                        };
                    }

                    return thisProjectStep;
                });

                this.close();
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }
    #module_nav {
        background-color: transparent;
    }
    .section-wrapper {
        margin: 30px auto;
    }
    .psr_avenir_book {
        font-size: .96em !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleReport.vue